import { useAuth0 } from "@auth0/auth0-react";
import { ApiError } from "../api/models/apiError";

export function useApiCallWithAuth(apiFunc: any) {

    const { getAccessTokenSilently } = useAuth0();

    const request = async (...args: any[]) => {

        let result:any= '';
        let accessToken = '';

        try {

            try{
                accessToken = await getAccessTokenSilently({ audience: `${process.env.REACT_APP_AUTH0_AUDIENCE}`, });
            }
            catch(e){
                console.log(`error getting access token`,e);
            }
            
            result = await apiFunc(accessToken, ...args);
        }
        catch (error: any) {

            const statusCode = error.response?.status || 500;

            if (error.response?.data) {
                throw new ApiError(error.response.data.message, statusCode);
            }
            else {
                throw new ApiError(error.message, statusCode);
            }
        }

    return result;
};

return{
    request
    };

}


